module.exports = __webpack_public_path__ + "images/interview-T-Mobile-2.svg";